module.exports = __webpack_public_path__ + "img/fo.d5f0901f.svg";